import request from '@/utils/request'

// 查询列表
export function apiRoutingCalendarListShifts (query) {
  return request({
    url: '/bom/routingCalendar/listShifts',
    method: 'get',
    params: query
  })
}

// 班次信息-班次名称
export function apiRoutingCalendarShiftsPullDownList (query) {
  return request({
    url: '/bom/routingCalendar/shiftsPullDownList',
    method: 'get',
    params: query
  })
}

// 新增、修改-列表
export function apiRoutingCalendarAddShifts (data) {
  return request({
    url: '/bom/routingCalendar/addShifts',
    method: 'post',
    data: data
  })
}

// 删除
export function apiRoutingCalendarRemoveShifts (id) {
  return request({
    url: `/bom/routingCalendar/removeShifts/${id}`,
    method: 'delete'
  })
}

// 新增班次
export function apiRoutingCalendarAddShiftsHead (data) {
  return request({
    url: '/bom/routingCalendar/addShiftsHead',
    method: 'post',
    data: data
  })
}
